<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">
        <a-space align="center">
          <div class="title_icon"></div>
          <div
            class="ant-descriptions-title"
            style="font-size: 16px; margin-bottom: 0px"
          >
            权证管理
          </div>
        </a-space>
        <a-button
          type="primary"
          style="float: right"
          @click="
            changeToDetail({
              webId: undefined,
              auditStatus: 1,
              isEditable: true,
            })
          "
          >新增权证</a-button
        >
      </div>

      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="提交时间">
            <a-range-picker
              v-model="queryParam.submitTime"
              style="width: 250px"
              :placeholder="['开始日期', '结束日期']"
              format="YYYY-MM-DD"
              valueFormat="YYYY-MM-DD"
              @change="onSearch"
            />
          </a-form-item>

          <a-form-item label="审核状态">
            <a-select
              v-model="queryParam.auditStatus"
              style="width: 160px"
              @change="onSearch"
            >
              <a-select-option :value="0">全部</a-select-option>
              <a-select-option :value="1">编辑中</a-select-option>
              <a-select-option :value="2">审核中</a-select-option>
              <a-select-option :value="3">审核通过</a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="权证编号">
            <a-input-search
              placeholder="权证编号"
              v-model="queryParam.certificateNumber"
              style="width: 220px"
              @search="onSearch"
            />
          </a-form-item>

          <br />
          <div style="margin-top: 4px">
            <a-form-item label="权证地址">
              <a-input-search
                placeholder="权证地址"
                v-model="queryParam.certificateAddress"
                style="width: 250px"
                @search="onSearch"
              />
            </a-form-item>
            <a-form-item label="权利人名称">
              <a-input-search
                placeholder="权利人名称"
                v-model="queryParam.obligeeName"
                style="width: 250px"
                @search="onSearch"
              />
            </a-form-item>

            <a-button type="primary" style="margin-top: 4px" @click="reset"
              >重置</a-button
            >
          </div>
        </a-form>
      </div>

      <a-table
        :pagination="table.pagination"
        :loading="table.loading"
        :columns="table.columns"
        :data-source="table.data"
        rowKey="webId"
        :scroll="{ x: 1200 }"
        @change="handleTableChange"
      >
        <span slot="index" slot-scope="text, record, index">
          {{
            (table.pagination.pageNo - 1) * table.pagination.pageSize +
            index +
            1
          }}
        </span>

        <span slot="propertyType" slot-scope="propertyType">
          {{ propertyType | propertyTypeText }}
        </span>

        <span slot="auditStatus" slot-scope="auditStatus">
          <a-badge
            v-if="auditStatus != null"
            :status="auditStatus | statusTypeFilter"
            :text="auditStatus | statusFilter"
          />
        </span>

        <span slot="operation" slot-scope="text, record">
          <!-- auditStatus=1：编辑、删除 -->
          <template v-if="record.auditStatus === 1">
            <a
              @click="changeToDetail({ ...record, isEditable: true })"
              style="color: #1890ff"
              >编辑</a
            >
            <a-divider type="vertical" />
            <a @click="deleteWarrant(record)" style="color: #1890ff">删除</a>
          </template>

          <!-- auditStatus=2：仅详情 -->
          <template v-else-if="record.auditStatus === 2">
            <a
              @click="changeToDetail({ ...record, isEditable: false })"
              style="color: #1890ff"
              >详情</a
            >
          </template>

          <!-- auditStatus=3：更新、详情 -->
          <template v-else-if="record.auditStatus === 3">
            <a
              @click="changeToDetail({ ...record, isEditable: true })"
              style="color: #1890ff"
              >更新</a
            >
            <a-divider type="vertical" />
            <a
              @click="changeToDetail({ ...record, isEditable: false })"
              style="color: #1890ff"
              >详情</a
            >
          </template>

          <!-- 兜底 -->
          <template v-else>
            <a
              @click="changeToDetail({ ...record, isEditable: false })"
              style="color: #1890ff"
              >详情</a
            >
          </template>
        </span>
      </a-table>
    </a-card>
  </div>
</template>

<script>
const columns = [
  {
    title: "序号",
    width: 80,
    scopedSlots: { customRender: "index" },
  },
  {
    title: "权证编号",
    dataIndex: "certificateNumber",
    width: 280,
  },
  {
    title: "权证类型",
    dataIndex: "propertyType",
    width: 100,
    scopedSlots: { customRender: "propertyType" },
  },
  {
    title: "权证地址",
    dataIndex: "certificateAddress",
    width: 300,
  },
  {
    title: "权利人名称",
    dataIndex: "obligeeName",
    width: 280,
  },
  {
    title: "状态",
    dataIndex: "auditStatus",
    width: 180,
    scopedSlots: { customRender: "auditStatus" },
  },
  {
    title: "提交时间",
    dataIndex: "submitTime",
    width: 200,
  },
  {
    title: "操作",
    width: 150,
    fixed: "right",
    align: "center",
    scopedSlots: { customRender: "operation" },
  },
];
const statusMap = {
  1: {
    status: "warning",
    text: "编辑中",
  },
  2: {
    status: "processing",
    text: "审核中",
  },
  3: {
    status: "success",
    text: "审核通过",
  },
};
const propertyType = {
  1: "产权",
  2: "使用权",
  3: "其他",
};
import { listWarrant, deleteWarrant } from "@/api/property/Property.js";
import { scrollToTop } from "@/utils/util";
export default {
  props: {
    toLedgerData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      //输入框
      queryParam: {
        submitTime: undefined,
        auditStatus: 0,
        certificateNumber: undefined,
        certificateAddress: undefined,
        obligeeName: undefined,
      },
      table: {
        data: [],
        loading: false,
        pagination: {
          showTotal: (total) => `共 ${total} 条`,
        },
        columns,
      },
    };
  },
  mounted() {
    this.queryParam.submitTime = this.toLedgerData.querySubmitTime;
    this.queryParam.auditStatus = this.toLedgerData.queryAuditStatus;
    this.queryParam.certificateNumber =
      this.toLedgerData.queryCertificateNumber;
    this.queryParam.certificateAddress =
      this.toLedgerData.queryCertificateAddress;
    this.queryParam.obligeeName = this.toLedgerData.queryObligeeName;
    this.table.pagination.current = this.toLedgerData.page;
    this.getTableDetails({
      pageSize: this.toLedgerData.pageSize,
      page: this.toLedgerData.page,
      submitTime: this.queryParam.submitTime,
      auditStatus: this.queryParam.auditStatus,
      certificateNumber: this.queryParam.certificateNumber,
      certificateAddress: this.queryParam.certificateAddress,
      obligeeName: this.queryParam.obligeeName,
    });
  },

  filters: {
    statusFilter(type) {
      return statusMap[type].text;
    },
    statusTypeFilter(type) {
      return statusMap[type].status;
    },
    propertyTypeText(type) {
      return propertyType[type] || "-";
    },
  },

  methods: {
    /**
     * 分页,查询
     * 根据条件筛选并重置分页,可复制
     */
    onSearch() {
      const pager = { ...this.table.pagination };
      pager.current = 1;
      this.handleTableChange(pager);
    },

    /**
     * 分页,点击下一页
     * 表格变化回调，用于分页,筛选和排序,可复制 参数略有修改
     */
    handleTableChange(pagination) {
      //设置重置按钮分页回到第一页
      const pager = { ...this.table.pagination };
      pager.current = pagination.current;
      this.table.pagination = pager;
      this.getTableDetails({
        pageSize: pagination.pageSize,
        page: pagination.current,
        submitTime: this.queryParam.submitTime,
        auditStatus: this.queryParam.auditStatus,
        certificateNumber: this.queryParam.certificateNumber,
        certificateAddress: this.queryParam.certificateAddress,
        obligeeName: this.queryParam.obligeeName,
      });
    },

    /**
     * 分页,默认第一页+查询
     * 获取选择层级下角色列表
     */
    getTableDetails(params = {}) {
      this.table.loading = true;
      listWarrant({
        page: 1,
        pageSize: 10,
        ...params,
      }).then((res) => {
        const pagination = { ...this.table.pagination };
        pagination.total = res.total;
        pagination.pageSize = res.pageSize;
        pagination.pageNo = res.pageNo;
        pagination.current = res.pageNo;
        if (res.pageNo != 1 && res.data.length == 0) {
          //用于新增或删除后自动刷新，避免页面为空现象
          this.getTableDetails({
            pageSize: res.pageSize,
            page: res.pageNo - 1,
            submitTime: this.queryParam.submitTime,
            auditStatus: this.queryParam.auditStatus,
            certificateNumber: this.queryParam.certificateNumber,
            certificateAddress: this.queryParam.certificateAddress,
            obligeeName: this.queryParam.obligeeName,
          });
        }
        if (res.pageNo == 1 || res.data.length != 0) {
          this.table.data = res.data;
          this.table.loading = false;
          this.table.pagination = pagination;
        }
      });
    },

    //重置表格查询
    reset() {
      //重置
      this.queryParam.submitTime = undefined;
      this.queryParam.auditStatus = 0;
      this.queryParam.certificateNumber = undefined;
      this.queryParam.certificateAddress = undefined;
      this.queryParam.obligeeName = undefined;
      this.onSearch();
    },

    /**
     * 刷新当前页(用于新增或删除后自动刷新)
     */
    refreshCurrentPage() {
      const pager = { ...this.table.pagination };
      if (pager.current == undefined || pager.current == 1) {
        this.onSearch();
      } else {
        this.handleTableChange(pager);
      }
    },

    deleteWarrant(record) {
      var _that = this;
      this.$confirm({
        title: "删除权证",
        content: "请确定是否删除权证，谨慎操作！",
        onOk() {
          deleteWarrant({
            webId: record.webId,
          })
            .then((res) => {
              if (res.code === "200") {
                _that.$notification.success({
                  message: "删除权证",
                  description: `成功`,
                });
                _that.refreshCurrentPage();
              } else {
                _that.$notification["error"]({
                  message: "错误",
                  description: res.msg,
                });
              }
            })
            .catch((err) => {
              _that.$notification["error"]({
                message: "错误",
                description:
                  ((err.response || {}).data || {}).message ||
                  "网络异常，请稍后再试",
                duration: 4,
              });
            });
        },
        onCancel() {},
      });
    },

    changeToDetail(val) {
      this.$emit("changeToDetail", {
        webId: val.webId,
        auditStatus: val.auditStatus,
        isEditable: val.isEditable,
        //当前页面查询信息
        page: this.table.pagination.pageNo,
        pageSize: this.table.pagination.pageSize,
        querySubmitTime: this.queryParam.submitTime,
        queryAuditStatus: this.queryParam.auditStatus,
        queryCertificateNumber: this.queryParam.certificateNumber,
        queryCertificateAddress: this.queryParam.certificateAddress,
        queryObligeeName: this.queryParam.obligeeName,
      });
      // 滚动到最顶端
      scrollToTop(this)
    },
  },
};
</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input {
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>
